import Reveal from '@/components/base/Reveal';
import { melonRanking } from '@/mocks/gossip';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { tagClass } from '@/pages/home/components/tagStyle';

function rankBadge(rank: number): string {
  if (rank === 1) return 'bg-primary-500 text-background-50';
  if (rank <= 3) return 'bg-accent-300 text-accent-950';
  return 'bg-background-200 text-foreground-600';
}

function DeltaMark({ delta, text }: { delta: string; text: string }) {
  if (delta === 'new') {
    return <span className="rounded bg-accent-500 px-1.5 py-0.5 text-[10px] font-medium text-accent-950">{text}</span>;
  }
  if (delta === 'up') {
    return (
      <span className="flex items-center gap-0.5 text-[11px] font-medium text-primary-700">
        <i className="ri-arrow-up-line text-[11px]" aria-hidden="true"></i>
        {text}
      </span>
    );
  }
  if (delta === 'down') {
    return (
      <span className="flex items-center gap-0.5 text-[11px] font-medium text-secondary-600">
        <i className="ri-arrow-down-line text-[11px]" aria-hidden="true"></i>
        {text}
      </span>
    );
  }
  return (
    <span className="flex items-center gap-0.5 text-[11px] font-medium text-foreground-400">
      <i className="ri-subtract-line text-[11px]" aria-hidden="true"></i>
      {text}
    </span>
  );
}

export default function MelonRanking() {
  return (
    <section id="rank" className="border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          index="02 / Ranking"
          title="今日大瓜榜"
          desc="按全网讨论量实时排序，每小时刷新一次。点开标题，就是当前热度最高的那一口。"
        />

        <div className="space-y-3">
          {melonRanking.map((item, i) => (
            <Reveal key={item.rank} delay={i * 40}>
              <div className="group flex cursor-pointer items-center gap-4 rounded-lg border border-background-200 bg-background-50 px-4 py-4 transition-colors hover:border-accent-300 hover:bg-accent-50/40 md:gap-6 md:px-6 md:py-5">
                <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md font-heading text-lg font-black md:h-12 md:w-12 md:text-xl ${rankBadge(item.rank)}`}>
                  {item.rank}
                </span>

                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className={`rounded border px-2 py-0.5 text-[11px] ${tagClass(item.tag)}`}>{item.tag}</span>
                    <DeltaMark delta={item.delta} text={item.deltaText} />
                  </div>
                  <h3 className="mt-1.5 truncate font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                    {item.title}
                  </h3>
                </div>

                <div className="shrink-0 text-right">
                  <p className="font-heading text-base font-bold text-foreground-900 md:text-lg">{item.heat}</p>
                  <p className="text-[11px] text-foreground-400">讨论热度</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}